import { useTranslation } from 'react-i18next';
import { useGetBalance } from 'src/hooks/useGetBalance';

export const DepositHeader = () => {
  const { t } = useTranslation();
  const { iconWithBalance } = useGetBalance();

  return (
    <div className="flex flex-col items-start mb-2.5">
      <div className="flex flex-col">
        <div className="flex flex-row text-base font-bold">
          <p className="text-dpip_text pr-1">{t('general.balance')}:</p>
          <p className="text-dpip_title">{iconWithBalance}</p>
        </div>
      </div>
      <p className="text-sm font-normal text-dpip_text">
        {t('accountWallet.chooseYourPaymentMethod')}
      </p>
    </div>
  );
};
